import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgFacebook = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.394 2.67l-2.674-.003c-3.004 0-4.945 1.835-4.945 4.676v2.156H7.087c-.232 0-.42.173-.42.387v3.124c0 .214.188.387.42.387h2.688v7.882c0 .214.188.388.42.388h3.508c.232 0 .42-.174.42-.388v-7.882h3.143c.233 0 .42-.173.42-.387l.002-3.124a.373.373 0 00-.123-.274.44.44 0 00-.298-.113h-3.144V7.67c0-.878.228-1.324 1.47-1.324l1.8-.001c.232 0 .42-.174.42-.387v-2.9c0-.215-.188-.388-.42-.388z"
      clipRule="evenodd"
    />
  </svg>
));
SvgFacebook.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgFacebook;
